import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'

// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API + '/api', // base_url
  timeout: 60000, // request timeout
  widthCredentials: true,
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      // console.log('----------',config);
      if(config.url.indexOf('xian') < 0) {
        if(!process.env.VUE_APP_BASE_API.includes(`suntekcorps`)) {
          config.baseURL = process.env.VUE_APP_BASE_API + '/api'
        }else{
          config.baseURL = process.env.VUE_APP_BASE_API + '/api'
        }
      }else{
        // 如果是测试环境，走代理
        if(!process.env.VUE_APP_BASE_API.includes(`suntekcorps`)) {

        }else{
          // 生产环境，去掉 xian
          config.url = process.env.VUE_APP_MS_API + config.url.replace('/xian','')
        }
      }
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers.Authorization = `Bearer ${store.getters.token}`
      // config.headers.Authorization = store.getters.systemCode // 2022-1月修改，加systemCode后台会报错，改为Authorization能接到
      // config.headers.systemCode = store.getters.systemCode
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    // 导出excel或者文件下载
    if(['blob'].includes(response.config.responseType)) {
      return response.data
    }
    if (res.type === 'application/octet-stream') {
      return response.data
    }
    // 西安测试系统接口兼容
    if(res.success){
      return res
    }
    if (res.code === 'success') {
      return res
    }
    if (res.code != '200') {
      if (res.code === '000008') {
        location.reload()
      }
      if (res.code === '508' || res.code === '512' || res.code === '514') {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            window.close()
          })
        })
      } else {
        Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(new Error('error'))
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
